import { axiosInstance } from '../../api/api';
import * as ActionTypes from '../actionTypes';

export const updateScanAttribute = (data) => (dispatch, getState) => {
	const { user } = getState();
	const { station } = user;

	const state = { ...data };

	const lineAndStationDataInLocalStorage =
		JSON.parse(localStorage.getItem(station.replaceAll(/[- ]/g, '_'))) || {};

	const lineAndStationData = {
		...lineAndStationDataInLocalStorage,
		attribute: state,
	};
	localStorage.setItem(
		station.replaceAll(/[- ]/g, '_'),
		JSON.stringify(lineAndStationData),
	);

	dispatch({
		type: ActionTypes.UPDATE_SCAN_ATTRIBUTE,
		...state,
	});
};

export const getScanAttributeDetailsForSerialNumber =
	(successCallback, errorCallback, serialNumber) => (dispatch) => {
		axiosInstance
			.get(`/station/part-attribute/${serialNumber}`)
			.then(({ data }) => {
				dispatch(updateScanAttribute({ ...data, serialNumber }));
				successCallback(data);
			})
			.catch((err) => {
				if (typeof errorCallback === 'function') {
					errorCallback(err);
				}
			});
	};

export const scannedAttributeAdd =
	(asnOrSequenceNumber, payload, successCallback, errorCallback) =>
	(dispatch) => {
		axiosInstance
			.post(`/station/part-attribute/${asnOrSequenceNumber}/add`, {
				...payload,
			})
			.then(({ data }) => {
				dispatch(updateScanAttribute(data));
				successCallback(data);
			})
			.catch((err) => {
				if (typeof errorCallback === 'function') {
					errorCallback(err);
				}
			});
	};
